import * as actions from 'embed/actions'
import * as React from 'react'
import { connect } from 'react-redux'

import { CommonDispatch, ViewportUpdateMessageBody } from 'embed/constants'
import Parent from 'embed/services/Parent'
import { captureParentDataError } from 'embed/constants/errors'
import { uiSelectedProductSelector } from 'embed/selectors/ui'
import { EmbedUpdateStepMessageBody, ParentData, Product } from '@evenfinancial/even-ts-static'

export interface Props {
  dispatchLoadParentData: (data: ParentData) => void
  dispatchViewportUpdate: (data: ViewportUpdateMessageBody) => void
  dispatchStepSelected: (data: EmbedUpdateStepMessageBody) => void
  parentLoading: boolean
  product: Product
  children?: React.ReactNode
}
const BrowserStateLoader: React.FC<Props> = ({
  children,
  dispatchLoadParentData,
  dispatchStepSelected,
  dispatchViewportUpdate,
  parentLoading,
}) => {
  React.useEffect(() => {
    Parent.getData()
      .then((data: ParentData) => {
        dispatchLoadParentData(data)
      })
      .catch((err) => {
        // Communication with Helper script failed
        // But we still try to start up
        dispatchLoadParentData({})
        captureParentDataError(err)
      })

    Parent.subscribeToViewportUpdates(dispatchViewportUpdate)
    Parent.subscribeToEmbedStepUpdates(dispatchStepSelected)
  }, [])

  return parentLoading === false ? <>{children}</> : null
}

const mapStateToProps = (state) => ({
  parentLoading: state.parent.loading,
  product: uiSelectedProductSelector(state),
})

const mapDispatchToProps = (dispatch: CommonDispatch) => ({
  dispatchLoadParentData: (data: ParentData) => {
    dispatch(actions.loadParentData(data))
  },
  dispatchViewportUpdate: (data: ViewportUpdateMessageBody) => {
    dispatch(actions.viewportUpdate(data))
  },
  dispatchStepSelected: (data: EmbedUpdateStepMessageBody) => {
    dispatch(actions.stepSelected(data.product, data.step))
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(BrowserStateLoader)
